import React from 'react';
import ReactDOM from 'react-dom';
import Visualizer from "./components/Visualizer";

ReactDOM.render(
  <div>
    <h1 className="main-header"></h1>
    <Visualizer />
  </div>
  ,document.getElementById('root')
);